import React, { Component } from 'react';
import firebase from 'firebase';
import withAuthorization from '../Session/withAuthorization';
import { compose } from 'recompose';
import AdminTable from './AdminTable';
import HomeTable from '../Home/HomeTable';

var admin = require("firebase-admin");

const UserList = ({ users }) =>
  <div className="">
    {
      Object.keys(users).map(key =>
        <div key={key}><span className="detail_key">{key} -</span> {users[key]}</div>
      )
    }
  </div>

const NameList = (name) => {
  return(<div className="welcome_user m-t-20">Welcome back {name}</div>)
}


class Admin extends Component {
  constructor(props){
    super();
    this.state = {
      data : '',
      tableData : '',
      uid : '',
      showChild : false
    }
  }
  
  componentWillMount() {
    var self = this , uid = firebase.auth().currentUser.uid
    firebase.database().ref('users/admin/details').child(uid).once('value',function(snap){
      self.setState({
        data : snap.val()
      })
    })
    firebase.database().ref('users/vendors').once('value',function(snap){
      var temp = snap.val() , data = [];
      Object.keys(temp).map(key => {
        data.push(temp[key].details);
        self.setState({
          tableData : data
        })
      })     
    })
  }

  render() {
    var name = this.state.data.name
    return (
      <div className="display_home">
        <div style={{width : '100%'}}>
          <div className="col-sm-12 col-md-12 col-lg-12 home_card">
            <div className="welcome_user m-t-20">Welcome back Admin</div>
            <div className="col-sm-6 col-md-6 col-lg-6 home_detail">
              <div className="col-sm-6 col-md-6 col-lg-6 card_details">
                <UserList users={this.state.data}  />
              </div>
            </div>
          </div> 
          <div className="col-sm-12 col-md-12 col-lg-12">
            <AdminTable data={this.state.tableData}  /> 
          </div>
        </div>
      </div>
    );
  }
} 


const authCondition = (authUser) => !!authUser;

export default compose(withAuthorization(authCondition))(Admin);
